export function areWeInIframe() {
  return (
    window !== window.parent ||
    window !== window.top ||
    window.self !== window.top
  )
}
